<script setup lang="ts">
  import { useCart } from '@storefront/storefront';
  import type { SharedOrder } from '@storefront/resources';

  interface Props {
    order?: SharedOrder;
  }

  defineProps<Props>();

  const { cart } = useCart();
</script>
<template>
  <footer class="order-footer">
    <FooterPaymentPartners class="order-footer__payment-partner" />
    <div class="order-footer__content">
      <div class="order-footer__column-left">
        <RouterLink :href="$route('web.termsAndCondition.index')" target="_blank">
          {{ $t('SHOP.CART.ACTION.TERMS_AND_CONDITIONS') }}
        </RouterLink>
        <RouterLink :href="$route('web.privacyPolicy.index')" target="_blank">
          {{ $t('SHOP.CART.ACTION.PRIVACY_POLICY') }}
        </RouterLink>
      </div>
      <div class="order-footer__column order-footer__column-middle">
        <CopyrightMessage class="order-footer__copy" />
      </div>
      <div class="order-footer__column order-footer__column-right">
        <p v-if="order?.id || cart?.id" class="order-footer__card-id">
          {{ $t('SHOP.CART.LABEL.ORDER_NUMBER') }}
          <span class="order-footer__id">{{ order?.id || cart?.id }}</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
  @use "@storefront/styles/mixins/media";

  :root {
    --sf-order-footer-border: var(--color-black);
    --sf-order-footer-background: var(--color-black);
  }

  .order-footer {
    border-top: 1px solid var(--sf-order-footer-border);

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.875rem;
      padding: 0.625rem 0;
      width: 98%;
      max-width: 1400px;
      margin: 0 auto;
    }

    &__payment-partner {
      padding: 2rem 0 1rem;
    }

    &__column-left {
      display: flex;
      flex-direction: column;
      row-gap: 0.125rem;

      a {
        text-decoration: underline;
        text-decoration-color: transparent;
        transition: text-decoration-color 0.2s ease-out;
      }

      @media(hover: hover) {
        a:hover {
          text-decoration-color: var(--primary-color);
        }
      }
    }

    &__card-id {
      font-size: 0.875rem;
    }

    &__id {
      font-weight: var(--font-weight-semi);
    }

  }

  @include media.query(md) {
    .order-footer {
      border: none;
      background-color: var(--sf-tile-background);

      &__content {
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
      }

      &__payment-partner {
        padding: 1rem 0;
      }

      &__column-left {
        flex-direction: row;
        order: -1;
        gap: 1rem;
        margin-right: 1rem;
      }

      &__column-right {
        order: 2;
        padding: 0.25rem 0;
      }

      &__column-middle {
        order: 3;
        width: 100%;
        text-align: center;
        margin-top: 0.375rem;
        padding-top: 0.375rem;
        border-top: 1px solid var(--sf-order-footer-border);
      }
    }
  }
</style>
